import * as React from 'react';

import { Typography, Paper, Box } from '@mui/material';
import { ViewState } from '@devexpress/dx-react-scheduler';
import {
        Scheduler,
        WeekView,
        Appointments,
        AllDayPanel,
        Toolbar,
        Resources
    } from '@devexpress/dx-react-scheduler-material-ui';

// classData import
import finalArr from '../../data/classTime/classData';


type Props = {}

// 현재 날짜의 기준점
const currentDate = new Date().toISOString().slice(0, 10);


const ClassInfo = (props: Props) => {


    const resources = [{
        fieldName: 'type',
        title: 'Type',
        instances: [
            { id: 'elementry_low', text: 'Elementry', color: '#4dd0e1' },
            { id: 'kids', text: 'Kids', color: '#4fc3f7' },
            { id: 'athelet', text: 'Athelet', color: '#42a5f5' },
            ],
        }];
        
  return (
    <Paper 
        sx={{ 
                width: '99%',
                boxShadow: 'rgba(0, 0, 0, 0.1) 1px 10px 20px',
                borderRadius: '15px',
                p: 3,
                // '@media (max-width: 1300px)': {
                //     minWidth: '1000px',
                //     padding: 1,
                //     mt: 5,
                // }
            }}>
        <Box sx={{
            width: '100%',
            '@media (max-width: 1300px)': {
                    minWidth: '100%',
                    padding: 1,
                    mt: 5,
                    overflowX: 'scroll', 
            }
        }}>
            <Typography 
                sx={{ 
                    fontFamily: 'Popins', 
                    fontSize: '2em', 
                    fontWeight: '500', 
                    letterSpacing: -1, 
                    textAlign: 'center',
                    mt: 3,
                    mb: -3,
                    '@media (max-width: 1300px)': { 
                        fontSize: '1.3em'
                    }
                    }}
                    >
                ⚽ YONSEI SCHEDULE ⚽
            </Typography>
            <Box 
                sx={{ 
                    // border: '1px solid black',
                    '@media (max-width: 1300px)': {
                        width: '1000px',
                        minWidth: '100%',
                        padding: 1,
                        mt: 5,
                        // overflowX: 'scroll', 
                    }
                    }}>
            <Scheduler
                data={finalArr}
            //   height={660}
            >
            <ViewState
                defaultCurrentDate={currentDate}
            />
            <WeekView
                startDayHour={13.5}
                endDayHour={20.5}
            />
            <Appointments />
            <Toolbar />
            <Resources
                data={resources}
            />
            </Scheduler>
            </Box>
        </Box>
    </Paper>
  )
}

export default ClassInfo